// 开发环境接口配置
// const APIURl = "https://recycle.u-power.com.cn"; //生产
const APIURl = "https://recycle.zhuxf.club"; //测试
// const APIURl = "http://203.83.232.93:30108"; //本地

module.exports = {
  APIURl: APIURl,
  comUploadUrl: process.env.VUE_APP_BASE_API + "/api/file/Uploader",
  // preViewUrl: APIURl + '/resources/', //预览文件
  preViewUrl: APIURl + "/api/file/Preview?fileName=", //预览文件
  downloadUrl: APIURl + "/api/file/Download?fileName=", //下载文件
  comUrl: process.env.VUE_APP_BASE_API,
};
